// Usage-gate configuration (#58) — single source of truth for the freemium
// gate. Anything that changes (store URLs, endpoint, quota, kill-switch)
// only changes here. Mirrors the performance-calculator's usageGate.js.

export const USAGE_ENDPOINT = 'https://www.amenai.net/wp-json/amenai/v1/notam/usage';

// Per-rolling-week free briefing quota. The server counts events over a
// 7-day window matched by cookie OR IP, so people behind one shared address
// (carrier NAT, a flying-club Wi-Fi) pool their count — accepted doctrine,
// same as the calculator. The gate fires when the returned count exceeds
// QUOTA — i.e. the 7th distinct briefing hits the interstitial.
export const QUOTA = 6;

// Master kill-switch. Flipped on 2026-09-26 (#58 Phase 5) once both apps were
// live in the public stores. The FIRST incident off-ramp needs no rebuild:
// the gate fails open on any non-2xx from the WordPress endpoint, so
// disabling that route turns the gate off for every client at once. This
// constant is the second, durable off-ramp (rebuild + deploy). The Flutter
// client never loads this SPA, so the web gate cannot reach an app user.
export const GATE_ENABLED = true;

// Store URLs (Apple id 6807961428, Play package net.amenai.notambriefer). The
// interstitial hides a platform's CTA while its URL is empty.
export const IOS_URL = 'https://apps.apple.com/app/notam-briefer/id6807961428';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=net.amenai.notambriefer';

// Cookie names. Prefix `nb_` for "notam-briefer" — parallels the
// calculator's `pc_` and Pilot Briefer's `pb_`.
export const COOKIE_UID = 'nb_uid';
export const COOKIE_UID_EXPIRES_DAYS = 365;

// Network timeout on the usage POST. Fail-open if exceeded — the briefer
// is a safety tool; a backend hiccup must not lock pilots out.
export const USAGE_TIMEOUT_MS = 5000;

// Last-known server count persisted so the tracker guard can block past
// quota across reloads. TTL = the rolling window length (PR #70 review): a
// 24h TTL let a tracker-only user (who never briefs, so never refreshes
// the count) walk past the block after a day. Recovery inside the window
// happens via any briefing attempt — an under-quota response resets the
// gate immediately.
export const GATE_STATE_STORAGE_KEY = 'nb_gate_state';
export const GATE_STATE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
